import { render, staticRenderFns } from "./RelatoriosDeClientes.vue?vue&type=template&id=13ed80fc"
import script from "./RelatoriosDeClientes.vue?vue&type=script&lang=ts"
export * from "./RelatoriosDeClientes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports